import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getEvents } from '../../../selectors/events';
import {
  getLeagues, getMatchTimelineEvents, getPeriodId, getEventType, getMarkets, getTimezone,
} from '../../../selectors/common';
import { getMatchId } from '../../../selectors/oddsHistory';
import { getEventDetails, getMatchTimeline } from '../../../selectors/matchTimeline';
import { MATCH_STATUS, PATHS } from '../../../constants';
import MatchDescriptionTable from './MatchDescriptionTable';
import MatchDetails from './MatchDetails';
import MatchTimelineDetails from './MatchTimelineDetails';
import { aGetMatchTimelineRequest } from '../../../reducers';
import { aClearMatchTimeline } from '../../../reducers/matchTimeline';

const mapToProps = (state) => ({
  events: getEvents(state),
  leagues: getLeagues(state),
  matchId: getMatchId(state),
  eventDetails: getEventDetails(state),
  matchTimeline: getMatchTimeline(state),
  matchTimelineEvents: getMatchTimelineEvents(state),
  periodId: getPeriodId(state),
  eventType: getEventType(state),
  markets: getMarkets(state),
  getTimezone: getTimezone(state),

});

const actionsToProps = (dispatch) => ({
  getMatchTimeline: (payload) => dispatch(aGetMatchTimelineRequest(payload)),
  clearMatchTimeline: (payload) => dispatch(aClearMatchTimeline(payload)),
});

class MatchTimeline extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    const { pathname } = window.location;
    const matchId = parseInt(
      this.props.matchId
      || (pathname.split(`${PATHS.MATCH_TIMELINE}/`)[1])
      || (pathname.split(`${PATHS.MATCH_TIMELINE_HISTORY}/`)[1]),
    );

    if (matchId) {
      this.props.getMatchTimeline({
        matchId,
        isHistory: this.props.isHistory,
      });
    }
  }

  componentWillUnmount() {
    this.props.clearMatchTimeline();
  }

  getMatchTimeDetails = () => {
    let timeDetails = '';
    if (this.props.eventDetails.periodId === this.props.periodId.HT) {
      timeDetails = MATCH_STATUS.HT;
    } else if (this.props.eventDetails.periodId === this.props.periodId.FT
      || this.props.eventDetails.flagMatchEnded) {
      timeDetails = MATCH_STATUS.FT;
    } else {
      const currentTime = new Date(Date.now());
      const t = (currentTime
        - new Date(this.props.eventDetails.startDate).getTime()) / (1000 * 60);
      timeDetails = `${Math.floor(t)}'`;
    }
    return timeDetails;
  };

  render() {
    if (this.props.eventDetails && this.props.matchTimeline) {
      return (
        <>
          <MatchDescriptionTable
            eventDetails={this.props.eventDetails}
            leagues={this.props.leagues}
          />

          <MatchDetails
            eventDetails={this.props.eventDetails}
            matchTimelineEvents={this.props.matchTimeline}
            periodId={this.props.periodId}
            getMatchTimeDetails={this.getMatchTimeDetails}
            eventType={this.props.eventType}
          />

          <MatchTimelineDetails />
        </>
      );
    }
    return null;
  }
}

export default connect(mapToProps, actionsToProps)(MatchTimeline);
